import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getNews, type NewsItem } from '@/api/cases';

function CaseInfoPage() {
  const { newsId } = useParams();
  const [news, setNews] = useState<NewsItem | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!newsId) return;
    setLoading(true);
    getNews(newsId)
      .then((res) => setNews(res.data))
      .catch((e) => setError(e.message || '加载失败'))
      .finally(() => setLoading(false));
  }, [newsId]);

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50 min-h-[60vh]">
      <div className="max-w-3xl mx-auto">
        <Link to="/support/cases" className="inline-flex items-center text-sm text-foreground-500 hover:text-primary-600 transition-colors mb-8">
          <i className="ri-arrow-left-line mr-1"></i>返回客户案例
        </Link>

        {loading ? (
          <p className="text-center text-foreground-400 py-12">加载中…</p>
        ) : error ? (
          <p className="text-center text-red-500 py-12">{error}</p>
        ) : !news ? (
          <p className="text-center text-foreground-400 py-12">案例不存在</p>
        ) : (
          <article className="bg-white rounded-2xl border border-background-200 overflow-hidden">
            {news.newsCover && (
              <div className="w-full h-56 md:h-72 overflow-hidden">
                <img src={news.newsCover} alt={news.newsTitle} className="w-full h-full object-cover object-top" />
              </div>
            )}
            <div className="p-6 md:p-10">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">{news.newsTitle}</h1>
              {news.createTime && <p className="text-xs text-foreground-400 mb-4">{news.createTime}</p>}
              {news.newsKeywords && (
                <div className="flex flex-wrap gap-2 mb-8">
                  {news.newsKeywords.split(/[，,]/).filter(Boolean).map((s, si) => (
                    <span key={si} className="px-3 py-1 text-xs font-medium bg-primary-50 text-primary-600 rounded-full whitespace-nowrap">{s.trim()}</span>
                  ))}
                </div>
              )}
              <div
                className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed [&_p]:mb-4 [&_img]:rounded-lg"
                dangerouslySetInnerHTML={{ __html: news.newsContent }}
              />
            </div>
          </article>
        )}
      </div>
    </section>
  );
}

export default CaseInfoPage;
